import * as React from 'react';
import styled from 'styled-components';
import { currencyFormatterWithDecimals } from '@assetmark/utilities';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';

export interface TTooltipDataProps {
  /** Tool Tip Model */
  averageReturn: number;
  averageReturnPercent: number;
  gainPercent: number;
  lossPercent: number;
}

const Wrapper = styled.div`
  padding: 6px 4px;
`;

const StyledH3 = styled.h3`
  margin: 5px 0;
`;

const FirstDiv = styled.div`
  margin-bottom: 12px;
`;

export const ToolTipDataComponent = ({
  averageReturn,
  averageReturnPercent,
  gainPercent,
  lossPercent,
}: TTooltipDataProps) => (
  <Wrapper>
    <h3>AVERAGE</h3>
    <FirstDiv className="row">
      <div className="col-6">
        ${currencyFormatterWithDecimals(averageReturn)}
      </div>
      <div className="col-6">
        <span className="arrow">&#x25B2;</span>
        {averageReturnPercent.toFixed(2)}%
      </div>
    </FirstDiv>
    <StyledH3>GAIN/LOSS RANGE</StyledH3>
    <div className="row">
      <div className="col-6">{lossPercent}%</div>
      <div className="col-6">{gainPercent}%</div>
    </div>
  </Wrapper>
);

ToolTipDataComponent.defaultProps = {
  averageReturn: 0,
  averageReturnPercent: 0,
  gainPercent: 0,
  lossPercent: 0,
};
